<template>
  <div class="loader d-flex justify-content-center">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">{{ Drupal.t("Loading") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  data() {
    return {
      Drupal: this.$drupal,
    }
  },
}
</script>
